import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    slots: {
        root: '',
    },
} satisfies TVConfig<typeof ui>['header'];
